// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3713r","filesListContainer":"PosDisputesFiles_filesListContainer__2_vEi","filesButton":"PosDisputesFiles_filesButton__2WQNm"};